
export default async function shopLoader({request})
{
    let url = new URL(await request.url);
    const searchTerm = url.searchParams.get("search");
    const newMachines = url.searchParams.get("new")
    let category= url.searchParams.get("category")
    //  const value=searchTerm+category+' '+url.searchParams
    //const pro=JSON.parse(products)
    
    console.log('?'+url.searchParams)
    
    try{
        const response = await fetch('/server/requests/getProducts.php'+'?'+url.searchParams, {method: 'GET',
    credentials: 'include'})
    if(response.ok)
        {
          
            const log= await response.json()  
            return {...log, category: category, searchTerm: searchTerm, newMachines: newMachines!==null};
        }
        else{
            throw new Error('Wystąpił błąd serwera')
        }

    }catch(e){
        console.log(e.message)
        return {success: false,message: e.message}
    }
}